import { Component } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AuthenticationService } from '../providers/index';
// import { CookieService } from 'angular2-cookie/services/cookies.service';
import {CookieService} from 'angular2-cookie/core';
import { DataService } from '../myservice/data-service';
import { ValidationService } from './validation.service';

@Component({
  templateUrl: 'loginpage.html',
  styleUrls: ['./loginpage.scss']
})
export class LoginComponent {
  model: any = {username : "" ,password:""};

  returnUrl: string;
  loginOK : boolean = true ;
  registracijaOK : boolean = false ;

  registracijaForm :boolean = false ;
  zaboraviliForm :boolean = false ;
  zaboravilijson : any[] ;
  zaboraviliodgovor : string ;
  // newProduct : any ={} ;
  newProduct : any = { Korime : "", Pozinb : "", Lozinka : ""} ;
  registracijajson : any[] ;
  public form: FormGroup; 
  public formreg: FormGroup;
  public formzaborav: FormGroup;

  zaboraviliValidateForm: any;
  zaboraviliOK : boolean = false ;
  newProductzaborav : any = { Korime : ""} ;

  constructor(private dataService:DataService ,private _cookieService:CookieService,private formBuilder: FormBuilder, private router: Router , private route: ActivatedRoute,private authenticationService: AuthenticationService) 
  {
      //   if(_cookieService.get('remember')){
      //  this.model.username=this._cookieService.get('username');
      //  this.model.password=this._cookieService.get('password');
      //   this.model.rememberme=this._cookieService.get('remember');
      // }
 }
// dobar primjer validation user password
// https://tutel.me/c/programming/questions/35474991/angular+2+form+validating+for+repeat+password
//
  ngOnInit() {
   
        // reset login status
        this.authenticationService.logout();
        
                // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
      
    //console.log ( "this.returnUrl",this.returnUrl) ;
    this.form = this.formBuilder.group ( {
      // uname: [null , Validators.compose ( [ Validators.required ] )] , 
     //   password: [null , Validators.compose ( [ Validators.required ] )]
    // password: [null , Validators.compose ( [ Validators.required , Validators.pattern('[\\\\w\\-\\s\\/]+') ] )]
      // -- bez space Validators.pattern(".*\\S.*[a-zA-z0-9 ]")
      'uname': ['', [Validators.required, ValidationService.emailValidator]],
      'password': ['' , [Validators.required ] ]
    } );

    this.formreg = this.formBuilder.group ( {
      // uname: [null , Validators.compose ( [ Validators.required ] )] , 
      // password: [null , Validators.compose ( [ Validators.required ] )]
      'korime': ['', [Validators.required, ValidationService.emailValidator]],
      'pozinb': ['' , [ Validators.required ] ],
      'lozinka': ['' , [ Validators.required ] ]
    
    } );
    this.formzaborav = this.formBuilder.group ( {
      // uname: [null , Validators.compose ( [ Validators.required ] )] , 
      // password: [null , Validators.compose ( [ Validators.required ] )]
      'korimezaborav': ['', [Validators.required, ValidationService.emailValidator]]
     
    
    } );
 
    // this.zaboraviliValidateForm  = this.formBuilder.group ( {
    //   korime: [null , Validators.compose ( [ Validators.required ] )] , 
    //   password: [null , Validators.compose ( [ Validators.required ] )]
    // } );
    // this.zaboraviliValidateForm = this.formBuilder.group({
    // Korime: this.formBuilder.control('',Validators.compose([
    //          Validators.pattern('[\\w\\-\\s\\/]+') 
    //          ]) )
    //       // Validators.pattern('[\\w\\-\\s\\/]+') 
    //  });

    //  this.zaboraviliValidateForm  = this.formBuilder.group({
    //   'Korime': ['', [Validators.required, ValidationService.emailValidator]]
    
    // });





  }

//   get Korime() {
//     return this.zaboraviliValidateForm.get('Korime');
// } 


  // serviceWRegistracijaPhp
  onSubmit() {
   
                // this._cookieService.put('username',this.model.username);
                // this._cookieService.put('password',this.model.password);
                // this._cookieService.put('remember',this.model.rememberme);
    //console.log ( "this.model.username",this.model.username) ;
       //console.log ( "this.model.password",this.model.password) ;
    this.authenticationService.login(this.model.username, this.model.password).subscribe(
      data => {
       //    this.router.navigate([this.returnUrl]);
         
          //console.log ( " .... login login ok ok this.returnUrl  "+this.returnUrl) ; 
           this.loginOK= true ; 
          if  ( localStorage.getItem('user_unamew')=== null || localStorage.getItem('user_passw')===null 
             ||  localStorage.getItem('user_unamew')==='null' || localStorage.getItem('user_passw')==='null') {
          this.loginOK= false ;  
          }
        //  console.log ( " login  this.loginOK  "+ this.loginOK) ; 
            if ( this.loginOK) {
              //  this._cookieService.put('username',this.model.username);
              //  this._cookieService.put('password',this.model.password);
              //  this._cookieService.put('remember',this.model.rememberme);ž
              
              localStorage.setItem('user_usernamew', this.model.username);
             this.router.navigate([  'home'  ]);  
            }  
 

           console.log ( " login  localStorage.getItem('user_unamew')  "+ localStorage.getItem('user_unamew')) ; 
     },
      error => {
      });
  }
 saveRegistracija(product) {
    // this._cookieService.put('username',this.model.username);
    // this._cookieService.put('password',this.model.password);
    // this._cookieService.put('remember',this.model.rememberme);
          //console.log ( "product.username",product.Korime) ;
          this.registracijaOK=false ;

                  this.dataService.serviceWRegistracijaPhp(product.Korime,product.Pozinb,product.Lozinka).subscribe( 

                  data => {
                  //    this.router.navigate([this.returnUrl]);
                  this.registracijajson = data ;
                  //console.log ( " ...this.registracijajson[0].Odgovor "+this.registracijajson[0].Odgovor) ; 
                  if ( this.registracijajson[0].Odgovor==="UREDU") {
                    this.registracijaOK=true ;
                  }  

                  },
          error => {

          });

}

saveZaboravili(product) {
  // this._cookieService.put('username',this.model.username);
  // this._cookieService.put('password',this.model.password);
  // this._cookieService.put('remember',this.model.rememberme);
      //   console.log ( "product.username",product.Korime) ;
         this.zaboraviliOK=false ;

        this.dataService.serviceWZaboraviliLozPhp(product.Korime).subscribe( 
        data => {
        //    this.router.navigate([this.returnUrl]);
        this.zaboravilijson = data ;
        //console.log ( " ...this.zaboravilijson[0].Odgovor "+this.zaboravilijson[0].Odgovor) ; 
        if ( this.zaboravilijson[0].Odgovor==="UREDU") {
          this.zaboraviliOK=true ;
          this.zaboraviliodgovor=this.zaboravilijson[0].Odgovor;

        }  
          },
          error => {

    });

}




  showRegistracijaForm(){
       this.registracijaForm = true ;
 }
cancelNewForm(){
  this.registracijaForm = false ;
  this.zaboraviliForm = false ;

this.registracijaOK= false ;
}
showZaboraviliForm(){
  this.zaboraviliForm = true ;
}

}



// WEBPACK FOOTER //
// ./src/app/mylogin/loginpage.ts